import carteMalin from "@/assets/images/carte_malin.png";
import coraMastercard from "@/assets/images/cora-mastercard.png";
import carrefourCard from "@/assets/images/carte-club-carrefour.svg"
import cartePass from "@/assets/images/carte-pass-carrefour.svg"

const getCardType = (type, number = null) => {
  const dict = {
    "C4": "cora Cpay Mastercard",
    "CP": "Malin Plus",
    "CM": "Malin",
  }

  if(type === "CRF") {
    if(isCarteClub(number)) {
      return "Club"
    }
      return "PASS"
  }
  return dict[type];
}

const getImgCardType = (type, number = null) => {
  const dict = {
    "C4": coraMastercard,
    "CP": carteMalin,
    "CM": carteMalin,
  }

  if(type === "CRF") {
    if(isCarteClub(number)) {
      return carrefourCard
    } 
    return cartePass
  }

  return dict[type];
}

const isCarteClub = (numero) => {
  return numero?.startsWith("9") || numero === undefined || numero === ""
}

export { getCardType, getImgCardType, isCarteClub }